// 계산·참조 데이터 모음. 서버 없이 브라우저에서 계산한다(정적 배포 가능).
// 사주 계산은 서버 Java 코드를 옮긴 것이다(lib/saju). 직업 목록은 data/jobs.json.
// 함수 이름과 반환 모양은 예전 서버 API 호출과 같게 유지한다.
import { analyzeSajuLocal } from '../lib/saju/analyze.js';
import { toLunar as lunarOf, toSolar as solarOf, hasLeap as leapOf } from '../lib/saju/lunar.js';
import JOBS from '../data/jobs.json';

export const INITIAL_STATS_VERSION = 'initial-stats-v4';

export async function analyzeSaju(body) {
  const saju = analyzeSajuLocal(body);
  if (saju?.statBasis?.version !== INITIAL_STATS_VERSION) {
    throw new Error('초기 능력치 계산 버전이 맞지 않습니다.');
  }
  return saju;
}

export const fetchJobs = async (field) => {
  const list = field ? JOBS.filter((job) => job.field === field) : JOBS;
  return structuredClone(list);
};

// 새 장면(v2)은 클라이언트 데이터를 쓴다. 옛 이벤트 목록은 서버에도 더 이상 없다.
export const fetchEventCatalog = async () => [];
export const fetchEventCandidates = async () => [];

// 양력 ↔ 음력
export const toLunar = async (year, month, day) => lunarOf(year, month, day);
export const toSolar = async (year, month, day, leap = false) => solarOf(year, month, leap, day);
export const hasLeap = async (year, month) => leapOf(year, month);
